/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { GetRegistrationOptionsOptions, GetRegistrationOptionsResponses } from '../models/GetRegistrationOptions'
import { client } from '#shared/api/client'

/**
 * @summary The challenge for a new account, or, under an upgrade session, for the
 * guest's first passkey with the guest's id as the user handle.
 * {@link /api/webauthn/register-options}
 */
export function getRegistrationOptions<ThrowOnError extends boolean = true>(options: Options<GetRegistrationOptionsOptions, ThrowOnError>): Promise<RequestResult<GetRegistrationOptionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/webauthn/register-options', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetRegistrationOptionsResponses, ThrowOnError>>
}
